import { useEffect, useState } from "react";
import ErrorsLayout from "~pages/Errors";
import useUsuario from "./fetchs/useUsuario";

const LocationVerifier = ({ children }) => {
  const [permissionState, setPermissionState] = useState(null);

  const { usuario } = useUsuario();
  useEffect(() => {
    let permissionStatus;

    const handlePermissionChange = () => {
      setPermissionState(permissionStatus.state);
    };

    navigator.permissions
      .query({ name: "geolocation" })
      .then((status) => {
        permissionStatus = status;
        setPermissionState(status.state);

        permissionStatus.onchange = handlePermissionChange;
      })
      .catch((error) => {
        console.error("Erro ao consultar a permissão de geolocalização:", error);
      });

    return () => {
      if (permissionStatus) {
        permissionStatus.onchange = null;
      }
    };
  }, []);

  useEffect(() => {
    navigator.geolocation.getCurrentPosition(() => {});
  }, [permissionState]);

  useEffect(() => {
    if(usuario?.ativo && usuario?.slugAcessos && (usuario?.slugAcessos['acesso-ao-menu-de-gestao-de-pesquisas'] || usuario?.slugAcessos?.includes('nao-capturar-gps'))) {
      setPermissionState('granted');
    }
  }, [usuario]);

  return (
    <>
      {permissionState == "granted" ? (
        children
      ) : (
        <ErrorsLayout
          title="O GPS não está habilitado"
          description="O VenD+ precisa de acesso ao seu GPS, por favor habilite o GPS nas configurações do navegador e recarregue a página."
          hideBack
          hideRefresh
          hideHome
        />
      )}
    </>
  );
};

export default LocationVerifier;
